import querystring from 'querystring';
import { ContextURL } from './ContextURL';
import { Editor, Platform } from './types';
class ContextStore {
  constructor() {
    this.cache = null;
    this.editorLabels = {
      '4447d3a3-a0df-4e2b-b92d-3e4af55fb726': Editor.EDITOR_X,
      '211d1383-13a6-4bef-85d1-bf5eda11c8a7': Editor.EDITOR,
      '46758c8d-b75d-4046-9f49-ba6fbafe5b56': Editor.ADI
    };
  }
  mapArea() {
    const areaMapping = {
      '/dashboard/': 'dashboard',
      'https://editor.wix.com/html/editor/': 'editor',
      'https://create.editorx.com/html/editor/': 'editorx',
      'https://editor.wix.com/website/builder': 'adi',
      '/account/sites/': 'mysites',
      '/studio/sites': 'mysites',
      '/account/': 'accountLevel',
      'https://support.wix.com/': 'helpCenter',
      'https://www.wix.com/contact': 'contact'
    };
    const urls = Object.keys(areaMapping);
    const areaUrl = urls.find(url => window.location.href.includes(url)) || '';
    return areaMapping[areaUrl] || 'unknown';
  }
  extractMetaSiteId() {
    var _window$location$sear;
    const parsedQueryParams = querystring.parse((_window$location$sear = window.location.search) == null ? void 0 : _window$location$sear.substring(1));
    const queryParams = Object.keys(parsedQueryParams).reduce((acc, key) => {
      acc[key] = String(parsedQueryParams[key]);
      return acc;
    }, {});
    if (queryParams != null && queryParams.metaSiteId) {
      return queryParams.metaSiteId;
    }
    const uuidRegex = new RegExp(/\b[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-\b[0-9a-fA-F]{12}\b/);
    const dashboardRegex = new RegExp(/dashboard\//);
    const urlRegex = new RegExp(dashboardRegex.source + uuidRegex.source);
    const match = window.location.href.match(urlRegex);
    if (match != null && match.length) {
      const uuidMatch = match[0].match(uuidRegex);
      return uuidMatch != null && uuidMatch.length ? uuidMatch[0] : '';
    }
    return '';
  }
  getArticleEditor(articleEditorLabel) {
    let editor = Editor.UNKNOWN;
    if (articleEditorLabel) {
      editor = this.editorLabels[articleEditorLabel.id] || Editor.UNKNOWN;
    }
    if (editor in Editor) {
      return editor;
    } else {
      return Editor.UNKNOWN;
    }
  }
  getHelpCenterSpecificContext() {
    const hcSpecificContext = {
      articleName: '',
      articleId: '',
      articleType: '',
      articleEditor: Editor.UNKNOWN,
      pageType: '',
      categoryId: ''
    };
    try {
      if (window.answersSdk) {
        const pageTypeNo = window.answersSdk.getVisiblePageType();
        hcSpecificContext.pageType = window.answersSdk.pages[pageTypeNo] || '';
        const article = window.answersSdk.getVisiblePageData();
        if (article != null && article.article) {
          var _article$article$labe;
          const articleEditorLabel = (_article$article$labe = article.article.labels) == null ? void 0 : _article$article$labe.find(label => {
            return Object.keys(this.editorLabels).includes(label.id);
          });
          const articleTypeNo = article.article.type;
          const articleType = window.answersSdk.articleTypes[articleTypeNo];
          Object.assign(hcSpecificContext, {
            articleName: article.article.title,
            articleId: article.article.id,
            articleType,
            articleEditor: this.getArticleEditor(articleEditorLabel),
            categoryId: article.article.categoryId
          });
        }
      }
    } catch (err) {}
    return hcSpecificContext;
  }
  getPage() {
    var _window$location$path, _window$location$sear2;
    const urlChunks = (_window$location$path = window.location.pathname) == null || (_window$location$path = _window$location$path.substring(1).split('/')) == null ? void 0 : _window$location$path.filter(String);
    const parsedQueryParams = querystring.parse((_window$location$sear2 = window.location.search) == null ? void 0 : _window$location$sear2.substring(1));
    const queryParams = Object.keys(parsedQueryParams).reduce((acc, key) => {
      acc[key] = String(parsedQueryParams[key]);
      return acc;
    }, {});
    return {
      numLevels: urlChunks == null ? void 0 : urlChunks.length,
      urlChunks,
      topLevelRoute: urlChunks[0],
      queryParams
    };
  }
  buildCache() {
    const contextUrl = new ContextURL(window.location.href);
    const page = this.getPage();
    return {
      domain: window.location.hostname,
      area: this.mapArea(),
      page,
      metaSiteId: this.extractMetaSiteId(),
      platform: Platform.DESKTOP,
      // Will be updated when needed
      parentUrl: window.location.href.split('?')[0],
      helpCenterSpecificContext: this.getHelpCenterSpecificContext(),
      mappingUrl: contextUrl.getCleanPathname() ?? '',
      mappingProduct: contextUrl.getProduct() ?? ''
    };
  }
  setUserData(userId, userExperience, careProfile, accountId) {
    if (!this.cache) {
      this.cache = this.buildCache();
    }
    this.cache.userId = userId;
    this.cache.accountId = accountId;
    this.cache.userExperience = userExperience;
    this.cache.careProfile = careProfile;
  }
  setPlatform(isMobile) {
    if (!this.cache) {
      this.cache = this.buildCache();
    }
    this.cache.platform = isMobile ? Platform.MOBILE : Platform.DESKTOP;
  }
  setIsWidget(isWidget) {
    if (!this.cache) {
      this.cache = this.buildCache();
    }
    this.cache.isWidget = isWidget;
  }
  getUserId() {
    var _this$cache;
    return (_this$cache = this.cache) == null ? void 0 : _this$cache.userId;
  }
  getAccountId() {
    var _this$cache2;
    return (_this$cache2 = this.cache) == null ? void 0 : _this$cache2.accountId;
  }
  getMetaSiteId() {
    if (!this.cache) {
      this.cache = this.buildCache();
    }
    return this.cache.metaSiteId;
  }
  getUserPriorityClass() {
    var _this$cache3;
    return ((_this$cache3 = this.cache) == null || (_this$cache3 = _this$cache3.careProfile) == null ? void 0 : _this$cache3.userPriorityClass) || '';
  }
  getUserExperience() {
    var _this$cache4;
    return (_this$cache4 = this.cache) == null ? void 0 : _this$cache4.userExperience;
  }
  getCareProfile() {
    var _this$cache5;
    return (_this$cache5 = this.cache) == null ? void 0 : _this$cache5.careProfile;
  }
  getDomain() {
    if (!this.cache) {
      this.cache = this.buildCache();
    }
    return this.cache.domain;
  }
  getArea() {
    if (!this.cache) {
      this.cache = this.buildCache();
    }
    return this.cache.area;
  }
  getPlatform() {
    if (!this.cache) {
      this.cache = this.buildCache();
    }
    return this.cache.platform;
  }
  getContextForBi() {
    if (!this.cache) {
      this.cache = this.buildCache();
    }
    return {
      context_domain: this.cache.domain,
      context_area: this.cache.area,
      context_page_numlevels: this.cache.page.numLevels,
      context_page_urlchunks: this.cache.page.urlChunks.join(','),
      context_page_toplevelroute: this.cache.page.topLevelRoute,
      context_page_queryparams: Object.keys(this.cache.page.queryParams).map(key => `${key},${this.cache.page.queryParams[key]}`).join(','),
      context_msid: this.cache.metaSiteId,
      context_platform: this.cache.platform,
      context_parenturl: this.cache.parentUrl,
      context_uuid: this.cache.userId || '',
      mapping_url: this.cache.mappingUrl,
      mapping_product: this.cache.mappingProduct,
      user_experience: this.cache.userExperience
    };
  }
  getContextForApi() {
    if (!this.cache) {
      this.cache = this.buildCache();
    }
    const biProfileGroups = {};
    const biProfileFields = {};
    return {
      domain: this.cache.domain,
      area: this.cache.area,
      page: this.cache.page,
      metaSiteId: this.cache.metaSiteId,
      platform: this.cache.platform,
      parentUrl: this.cache.parentUrl,
      userId: this.cache.userId || '',
      accountId: this.cache.accountId,
      userExperience: this.cache.userExperience,
      helpCenterSpecificContext: this.cache.helpCenterSpecificContext,
      mappingUrl: this.cache.mappingUrl,
      mappingProduct: this.cache.mappingProduct,
      isWidget: this.cache.isWidget ?? true,
      careProfile: this.cache.careProfile,
      biProfileGroups,
      biProfileFields
    };
  }
  clear() {
    this.cache = null;
  }
}
export const contextStore = new ContextStore();
//# sourceMappingURL=ContextStore.js.map